"use strict";
/**
 * Settlement/Termination enums — finiquito and liquidación.
 * Per Mexican Federal Labor Law (LFT).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEPARATION_TYPE_LABELS = exports.SeparationType = void 0;
var SeparationType;
(function (SeparationType) {
    SeparationType["voluntaryResignation"] = "voluntary_resignation";
    SeparationType["unjustifiedDismissal"] = "unjustified_dismissal";
    SeparationType["constructiveDismissal"] = "constructive_dismissal";
    SeparationType["endOfContract"] = "end_of_contract";
    SeparationType["mutualAgreement"] = "mutual_agreement";
})(SeparationType || (exports.SeparationType = SeparationType = {}));
exports.SEPARATION_TYPE_LABELS = {
    [SeparationType.voluntaryResignation]: "Renuncia voluntaria",
    [SeparationType.unjustifiedDismissal]: "Despido injustificado",
    [SeparationType.constructiveDismissal]: "Rescisión imputable al patrón",
    [SeparationType.endOfContract]: "Fin de contrato",
    [SeparationType.mutualAgreement]: "Mutuo acuerdo",
};
